require('core-js');require('regenerator-runtime/runtime');import $ from 'jquery';
window.jQuery = $;
window.$ = $;
import 'whatwg-fetch';

// FOUNDATION
require('../../../wdh-foundation/dgs/dgs-api.js');
require('../../../wdh-foundation/dgs/dgs-events.js');
// FEATURE
require('../../corporate-template/js/feature/intro-banner.js');
require('../../corporate-template/js/feature/text-image-spot');
require('./feature/wdh-remotecare-admin-panel');

// PROJECT
require('./project/header');
require('@demant/wdh-gdpr/lib/default.implementation.js');